import { GET } from '../request'

export const getCentrosEstudio = () =>
  GET('/api/agora/datos/centro-estudios/list')
